<script>
import formItem from "./formItem.vue";
const classNames = "customForm";
import "./customForm.less";
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    events: {
      type: Function,
      default: () => {},
    },
    bindProps: {
      type: Object,
      default: () => {},
    },
    formRef: {
      type: [Object,String],
      default: ""
    },
    ruleForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    formItem,
  },
  data() {
    return {
      id: 0,
      datas: [],
    };
  },
  computed: {
    // formRefs: {
    //   get() {
    //     return this.formRef;
    //   },
    //   set(news) {
    //     console.log(news,'formRefs-----')
    //     this.$emit("update:formRef", news);
    //     return news;
    //   },
    // },
    ruleForms: {
      get() {
        return this.ruleForm;
      },
      set(news) {
        this.$emit("update:ruleForm", news);
      },
    },
  },
  watch:{
    '$refs':{
      immediate:true,
      deep:true,
      handler(news){
       this.$nextTick(()=>{
        if(news.formRefss){
          this.$emit("update:formRef", news.formRefss);
        }
       })
       
      }
    },
    
  },
  provide: function () {
    return {
      ruleForms: this.ruleForms,
    };
  },
  render(h) {
    return (
      <div class={classNames}>
        <el-form
          props={{
            model: this.ruleForms,
            ...this.bindProps,
            on: {
              ...this.events,
            },
           
          }}
          ref='formRefss'
        >
          {this.$slots.default
            ? this.$slots.default
            : this.data.map((item, index) => {
                return <formItem items={item} key={index+Date.now()}></formItem>;
              })}
        </el-form>
      </div>
    );
  },
};
</script>
